// Generated by CoffeeScript 2.7.0
import ReactiveCalculationMixin from 'trunks/vue/share/components/fieldable/reactive_calculation.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ResponseFieldListFieldable from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import AttachmentLayer from 'trunks/vue/admin/compositions/attachment_layer.js';

export var ResponseModal = Vue.extend({
  mixins: [ReactiveCalculationMixin],
  components: {
    Modal: Modal,
    FieldList: ResponseFieldListFieldable
  },
  data: function() {
    return {
      total_count: 1,
      current_index: 1,
      response: {},
      fieldable: {},
      responseableGID: null,
      hasPrevResponse: true,
      hasNextResponse: true,
      editing: false,
      valid: true,
      disappearedFieldIds: [],
      responseFieldList: null
    };
  },
  template: `<Modal :title='fieldable.title' extendClass='response-modal' ref='modal'>
  <template>
    <div class="modal-body"
         v-if='response'
         :class="{ 'with-sticky-content': response.isPersisted() }">
      <div class="sticky-content justify-box" v-if='response.isPersisted()'>
        <div class="content justify-box">
          <div class="content">
            <span>{{ user_name }}</span>
            <span>&nbsp;填写于&nbsp;</span>
            <span>{{ created_at }}</span>
          </div>
          <template v-if="!editing">
            <div class="btn text-btn btn-default" @click='printResponse'>
              <i class="slp-printer"></i>
            </div>
            <div class="btn text-btn btn-default" @click='editResponse'>
              <i class="slp-pencil"></i>
            </div>
            <div class="btn text-btn btn-default" @click='removeResponse'>
              <i class="slp-trash"></i>
            </div>
          </template>
          <template v-else>
            <div class="btn text-btn btn-save" @click='saveResponse' :class="{ 'disabled': !valid }">
              <i class="slp-download-list"></i>
              <span>保存</span>
            </div>
          </template>
        </div>
        <div class="indexer vertical-middle" v-if="!editing">
          <div class="btn icon-btn" @click='previewPrev' :disabled='!hasPrevResponse'>
            <i class="slp-chevron-left"></i>
          </div>
          <div class="indexer-info">{{ current_index }}/{{ total_count }}</div>
          <div class="btn icon-btn" @click='previewNext' :disabled='!hasNextResponse'>
            <i class="slp-chevron-right"></i>
          </div>
        </div>
      </div>
      <FieldList :fields='fieldable.fields'
                 :entries='response.entries'
                 :response='response'
                 :isAdmin='true'
                 :editing='editing'
                 extendClass='form-field-group'
                 :disappearedFieldIds='disappearedFieldIds'
                 @valueChange='onValueChangedFunc'
                 @validChange='fieldListValidChange'
                 @displayAttachment='displayAttachmentIfNeed'
                 ref='fieldsView' />
    </div>
    <div class="blankslate" v-else>
      <p>该页没有数据了</p>
    </div>
  </template>
  <template slot='footer'>
    <div class="modal-footer" v-if='response.isNew()'>
      <button class="outlined btn-default" @click='close'>取消</button>
      <button @click='addResponse'>提交</button>
    </div>
    <div v-else></div>
  </template>
</Modal>`,
  mounted: function() {
    return this.responseFieldList = this.$refs.fieldsView;
  },
  computed: {
    user_name: function() {
      var ref;
      return ((ref = this.response.user) != null ? ref.name : void 0) || '匿名用户';
    },
    created_at: function() {
      return new Date(this.response.created_at).strftime('YYYY-MM-DD hh:mm');
    },
    responseAttachments: function() {
      return this.responseFieldList.allFieldsAttachments;
    },
    hasCalculationFields: function() {
      return _.chain(this.fieldable.fields).map(function(field) {
        if (field.type === 'Field::Detail') {
          return field.children;
        } else {
          return field;
        }
      }).flatten().any({
        type: 'Field::Calculation'
      }).value();
    }
  },
  watch: {
    editing: function() {
      return this._scrollFieldListIntoView();
    }
  },
  methods: {
    removeResponse: function() {
      if (this._removeRequesting) {
        return;
      }
      if (this._removeRequesting == null) {
        this._removeRequesting = true;
      }
      return newConfirm({
        title: `确认删除 ${this.user_name} 的填写记录?`,
        message: "删除操作不可撤销，请确认操作。",
        confirmButtonText: '删除',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this.$emit('requestRemove', this.current_index - 1, this);
      });
    },
    printResponse: function() {
      return window.open(`/admin${this.responseableGID.toPath()}/responses/${this.response.id}/print`);
    },
    editResponse: function() {
      return this.editing = true;
    },
    _scrollFieldListIntoView: function() {
      return this.$refs.fieldsView.$el.scrollIntoView(true);
    },
    saveResponse: function() {
      var entries, response_data;
      if (!this.valid) {
        return;
      }
      entries = this.$refs.fieldsView.getEntries();
      response_data = {
        response: {
          entries_attributes: entries
        }
      };
      this.editing = false;
      return Skylark.Libs.Ajax.patch(`/admin${this.responseableGID.toPath()}/responses/${this.response.id}`, {
        data: response_data,
        contentType: 'application/json; charset=utf-8',
        success: (data, xhr) => {
          this.response = new Skylark.App.Model.Response(data);
          this.$emit('responseChange', this.response);
          return newAlertify('更新成功', {
            type: 'success'
          });
        }
      });
    },
    previewPrev: function() {
      if (!this.hasPrevResponse) {
        return;
      }
      return this.preview(-1);
    },
    close: function() {
      return this.$refs.modal.close();
    },
    previewNext: function() {
      if (!this.hasNextResponse) {
        return;
      }
      return this.preview(1);
    },
    preview: function(delta) {
      if (this._previewRequesting) {
        return;
      }
      if (this._previewRequesting == null) {
        this._previewRequesting = true;
      }
      return this.$emit('requestPreview', this.current_index - 1 + delta, this);
    },
    resetOptions: function(options = {}) {
      _.extend(this, {
        hasNextResponse: true,
        hasPrevResponse: true
      }, options);
      this._removeRequesting = false;
      return this._previewRequesting = false;
    },
    fieldListValidChange: function(valid) {
      return this.valid = valid;
    },
    displayAttachmentIfNeed: function(attachment) {
      var attachment_index;
      attachment_index = _.indexOf(this.responseAttachments, attachment);
      if (this.attachmentLayer) {
        this.attachmentLayer.attachments = this.responseAttachments;
        this.attachmentLayer.updateCurrentIndex(attachment_index);
        return this.attachmentLayer.open();
      } else {
        return this.attachmentLayer = new AttachmentLayer({
          el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('layer_container'),
          data: {
            attachments: this.responseAttachments,
            currentIndex: attachment_index
          }
        });
      }
    },
    isValid: function() {
      if (!this.valid) {
        newAlertify('填写不合法', {
          type: 'error'
        });
        this.$refs.fieldsView.displayFirstError();
      }
      return this.valid;
    },
    beforeSave: function() {
      var response;
      if (!this.isValid()) {
        return false;
      }
      response = this._getNewResponse();
      if (!this.isValid()) {
        return false;
      }
      return response;
    },
    addResponse: function() {
      var response, spinner;
      response = this.beforeSave();
      if (!response) {
        return;
      }
      spinner = newSpinner({
        parent: this.$refs.modal.$refs.content
      });
      return Skylark.Libs.Ajax.post(`/admin${this.responseableGID.toPath()}/responses`, {
        data: response,
        contentType: 'application/json; charset=utf-8',
        success: (data, xhr) => {
          return spinner.$on('closed', () => {
            this.$emit('newResponseAdded', data);
            newAlertify('添加成功', {
              type: 'success'
            });
            return this.close();
          });
        },
        error: function(xhr) {
          return spinner.$on('closed', function() {
            return newAlertify('添加失败', {
              type: 'error'
            });
          });
        },
        complete: function() {
          return spinner.close();
        }
      });
    },
    _getNewResponse: function() {
      return {
        response: {
          entries_attributes: this.$refs.fieldsView.getEntries()
        }
      };
    }
  }
});

export var newResponseModal = function(options = {}) {
  return new ResponseModal({
    el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('modal_container'),
    data: options
  });
};

export default ResponseModal;
